import styled from 'styled-components';

export const StyledAboutFeaturesSection = styled.div`
  .about-features-section {
    width: 100%;
    padding: 100px 16px;

    &__inner {
      margin: 0 auto;
      max-width: 1200px;
    }

    &__heading {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin-bottom: 60px;
      gap: 16px;

      p:last-child {
        max-width: 600px;
        color: ${({ theme }) => theme.colors.boulder};
      }
    }

    &__grid {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;

      @media (max-width: 900px) {
        grid-template-columns: repeat(2, 1fr);
      }

      @media (max-width: 600px) {
        grid-template-columns: 1fr;
      }
    }

    &__card {
      background: ${({ theme }) => theme.colors.white};
      border-radius: 16px;
      padding: 32px;
      display: flex;
      flex-direction: column;
      gap: 16px;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.06);
      transition:
        transform 0.3s ease,
        box-shadow 0.3s ease;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
      }

      p {
        color: ${({ theme }) => theme.colors.boulder};
      }
    }

    &__card-icon {
      width: 56px;
      height: 56px;
      border-radius: 12px;
      background: linear-gradient(135deg, #7c3aed 0%, #a855f7 100%);
      display: flex;
      align-items: center;
      justify-content: center;

      svg {
        font-size: 24px;
        color: ${({ theme }) => theme.colors.white};
      }
    }
  }
`;
